export const SET_IS_LOADING_CONVERSATION = 'SET_IS_LOADING_CONVERSATION';
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const SET_ACTIVE_CONVERSATION_ID = 'SET_ACTIVE_CONVERSATION_ID';

export const SET_IS_LOADING_MESSAGES = 'SET_IS_LOADING_MESSAGES';
export const SET_MESSAGES_ON_CONVERSATION = 'SET_MESSAGES_ON_CONVERSATION';
export const SET_IS_SENDING_MESSAGE = 'SET_IS_SENDING_MESSAGE';
export const SET_SHOULD_DISPLAY_TYPING_EVENT = 'SET_SHOULD_DISPLAY_TYPING_EVENT';

export const SET_IS_LOADING_PROJECT_EVENTS = 'SET_IS_LOADING_PROJECT_EVENTS';



// WEBPACK FOOTER //
// ./src/taskflex/conversations/store/_types.js